import type { FaireProductEntity } from "../../entity_types/product";

export const p_6srxqnwun2: FaireProductEntity = {
  token: "p_6srxqnwun2",
  type: "product",
  name: "Spice and Wolf, Vol. 3",
  brandToken: "b_bomzcs63",
  brandName: "Hachette Book Group",
  imageUrl: "https://cdn.faire.com/fastly/b46eb697a305ceed4593b16e7fd6c6f4f8dee2c2606b630481096d1361b456a2.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/8b0c4f63ae84a4d0c8310d5316088c22b5f30e0e3fe81620125095bf406fa468.webp"
  ],
  priceDollars: 6.5,
  description: "Parental Advisory: Explicit Content Warning\n\nLawrence and Holo are on the run, desperate to save both their profits and their lives! With enforcers from a rival company in pursuit, though, Holo may need to resort to extreme measures to safeguard herself and her traveling companion. Can Lawrence cope with the terror-inspiring true form of Holo the Wisewolf?!",
  tags: [],
  msrpDollars: 13,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:06:22.758Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
